export const setSinkId = {
  inserted(el,binding){
    if(el.setSinkId) el.setSinkId(binding?.value)
  },
  update(el,binding){
    if(el.setSinkId) el.setSinkId(binding?.value)
  },
}